<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<div v-if="false" class="tips_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<!-- <div class="tips_main">
					<div class="left">
						<img class="tips" style="position: relative;top: -2px;" src="../../assets/img_zt/icon_1.webp" />
						<span style="color: #E15A00;font-weight: bold;font-size: 16px;position: relative;top: 7px;">&ensp;Happy 4th of July!&ensp;</span>
						<span style="font-size: 16px;position: relative;top: 7px;">&ensp;Use code <span style="font-size: 16px;font-weight: bold;">CorDx21</span> at checkout to get <span style="font-size: 16px;font-weight: bold;">21% off</span> your purchase on
						<a style="color: #2173FF !important;font-weight: bold;text-decoration: underline;" href="https://al21.com/products/cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test" target="_blank">AL21</a>,</span>
						
						&ensp;&ensp;&ensp;<img class="tips" style="position: relative;top: 3px;" src="../../assets/img_zt/icon_3.webp" />
						<span style="font-size: 16px;position: relative;top: 7px;">&ensp;Special July 4th One-Day Sale:&ensp;<span style="font-size: 16px;font-weight: bold;">21% Off</span> on
						<a style="color: #2173FF !important;font-weight: bold;text-decoration: underline;" href="https://www.amazon.com/At-Home-CorDx-COVID-19-Accurate-Results/dp/B0D2DQBJS2?maas=maas_adg_EAA5E1BA3E43283FC76983FA6B2A9AFF_afap_abs&ref_=aa_maas&tag=maas" target="_blank">Amazon</a>.</span>
					</div>
					<div class="right">
						<img src="../../assets/img_zt/icon_2.webp" />
					</div>
				</div> -->
				<!--通知-->
				<div class="notice_box">
					<div class="icon left">
						<div class="el">
							<img class="el" src="../../assets/obituary/lz.gif" />
						</div>
						<div class="el">
							<img class="el" src="../../assets/obituary/lz.gif" />
						</div>
						<div class="el">
							<img class="el" src="../../assets/obituary/lz.gif" />
						</div>
					</div>
					<div class="notice-wrap">
						<van-notice-bar
							left-icon=""
							background="#000000"
							color="#ffffff"
						>
							<div class="marquee">
								<div class="marquee-content">
									<!-- 第一份 -->
									<div class="notice-text"></div>
									<!-- 第二份（无缝复制） -->
									<div class="notice-text"></div>
								</div>
							</div>
						</van-notice-bar>
					</div>
					<div class="icon right">
						<div class="el">
							<img class="el" src="../../assets/obituary/lz.gif" />
						</div>
						<div class="el">
							<img class="el" src="../../assets/obituary/lz.gif" />
						</div>
						<div class="el">
							<img class="el" src="../../assets/obituary/lz.gif" />
						</div>
					</div>
				</div>
				<!--通知-->
			</div>
			<!--导航-->
			<div class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<!-- <div class="icon_left animate__animated animate__fadeInLeft" @click="bannerLeftClick">
					<van-icon name="arrow-left" color="#ffffff" size="20px" />
				</div>
				<div class="icon_right animate__animated animate__fadeInRight" @click="bannerRightClick">
					<van-icon name="arrow" color="#ffffff" size="20px" />
				</div> -->
				<van-swipe
					:autoplay="5000"
					:show-indicators="false"
					:loop="true"
					ref="swipeDom"
					:stop-propagation="false"
					:touchable="true"
					@change="spChange"
				>
					<!-- <van-swipe-item>
						<div class="banner_el banner_el2">
							<div v-if="isRload" class="msg_box2">
								<div class="left">
									<img class="img1" src="../../assets/banner/PC/3687.webp" />
									<div class="btn_box">
										<img class="btn1" src="../../assets/banner/PC/button_01pc.webp" @click="goBanner(3)" />
										<img class="btn2" src="../../assets/banner/PC/button_02pc.webp" @click="goBanner(4)" />
									</div>
									<div class="btn_box2">
										<img class="btn3" style="margin-right: 95px;" src="../../assets/banner/PC/button_pc.webp" @click="goBanner(6)" />
										<img class="btn3" src="../../assets/banner/PC/amazon_pc2.webp" @click="goBanner(5)" />
									</div>
								</div>
								<div class="right"></div>
							</div>
							<img class="bg_banner" src="../../assets/banner/PC/bg_pc.webp" />
						</div>
					</van-swipe-item> -->
					<van-swipe-item>
						<div class="banner_el banner_el2">
							<div v-if="isRload" class="msg_box2">
								<div class="left">
									<div class="btn_box3">
										<van-button
											class="btn_el"
											type="primary"
											color="#f77a1d"
											style="border-radius: 12px;"
											@click="goBanner(14)"
										>CONTACT US&ensp;▶</van-button>
									</div>
								</div>
								<div class="right"></div>
							</div>
							<img class="bg_banner" src="../../assets/banner/PC/20261022/pc.webp" />
						</div>
					</van-swipe-item>
					<van-swipe-item>
						<div class="banner_el banner_el7">
							<div v-if="isRload" class="msg_box2">
								<div class="left">
									<img class="img1" src="../../assets/banner/PC/20260729/text.webp" />
									<div class="btn_box">
										<img class="btn1" src="../../assets/banner/PC/20260729/btn.webp" @click="goBanner(13)" />
									</div>
								</div>
								<div class="right"></div>
							</div>
							<img class="bg_banner" src="../../assets/banner/PC/20260729/bg.webp" />
						</div>
					</van-swipe-item>
					<van-swipe-item>
						<div class="banner_el">
							<!-- <img class="bg_banner" src="../../assets/obituary/pc.webp" /> -->
							<img class="bg_banner" src="../../assets/banner/PC/20260617/desktop.png" @click="goBanner(12)" />
						</div>
					</van-swipe-item>
					<van-swipe-item>
						<div class="banner_el banner_el6">
							<div v-if="isRload" class="msg_box">
								<div class="left"></div>
								<div class="right">
									<img class="img1" src="../../assets/banner/PC/20251009/banner_RSV_text.webp" />
									<div class="btn_box">
										<!-- <img class="btn1" src="../../assets/banner/PC/20251009/RSV_btn.webp" @click="goBanner(10)" /> -->
										<img class="btn1" src="../../assets/banner/PC/20251009/more.webp" @click="goBanner(11)" />
									</div>
								</div>
							</div>
							<img class="bg_banner" src="../../assets/banner/PC/20251009/banner_RSV_bg.webp" />
						</div>
					</van-swipe-item>
					<!-- <van-swipe-item>
						<div class="banner_el banner_el4">
							<div v-if="isRload" class="msg_box2">
								<div class="left"></div>
								<div class="right">
									<img class="img1" src="../../assets/banner/PC/20250728/2.webp" />
									<div class="btn_box">
										<img class="btn1" src="../../assets/banner/PC/20250728/7.webp" @click="goZc" />
									</div>
								</div>
							</div>
							<img class="bg_banner" src="../../assets/banner/PC/20250728/1.webp" />
						</div>
					</van-swipe-item> -->
					<van-swipe-item>
						<div class="banner_el banner_el5">
							<div v-if="isRload" class="msg_box2">
								<div class="left">
									<img class="img1" src="../../assets/banner/PC/20250728/4.webp" />
								</div>
								<div class="right">
									<img class="img1" src="../../assets/banner/PC/20250728/6.webp" />
								</div>
							</div>
							<img class="bg_banner" src="../../assets/banner/PC/20250728/3.webp" />
						</div>
					</van-swipe-item>
					<!-- <van-swipe-item>
						<div class="banner_el">
							<div v-if="isRload" class="msg_box"
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							>
								<div class="left" style="flex: 1.1;">
									<div class="tit" style="font-size: 60px;font-weight: bold;">
										BECOME A
									</div>
									<div class="tit" style="font-size: 60px;font-weight: bold;">
										DISTRIBUTION PARTNER
									</div>
									<div class="txt" style="padding-top: 0px;color: rgb(249, 150, 59);">
										Recieve A Complimentary Sample Rapid Test Kit
									</div>
									<div class="txt" style="padding-top: 10px;">
										CorDx collaborate's with a global network of partners that support the distribution of world-class diagnostics.
									</div>
									<div class="btn_box_more btn_box" style="margin-top: 60px;padding: 0 30px;background-color: #0B318F;color: #ffffff;" @click="goBanner(9)">
										LEARN MORE <img src="../../assets/img_public/icon.webp" />
									</div>
								</div>
								<div class="right"></div>
							</div>
							<img class="bg_banner" src="../../assets/banner/PC/20241119-080814.png" @click="goBanner(9)" />
						</div>
					</van-swipe-item> -->
					<!-- <van-swipe-item>
						<div class="banner_el">
							<div v-if="isRload" class="msg_box"
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							>
								<div class="left">
									<div class="tit" style="font-size: 50px;">CorDx Tyfast</div>
									<div class="tit" style="font-size: 50px;">COVID-19 Ag Rapid Test</div>
									<div class="txt" style="font-size: 20px;padding-top: 10px;">Results in just 10 minutes when you need them most!</div>
									<div style="padding-top: 30px;padding-bottom: 40px;">
										<div style="display: inline-block;margin-right: 50px;text-align: center;">
											<img style="width: 60px !important;min-width: 60px !important;" src="../../assets/img/icon_Accurate.png" /><br />
											<span style="display: inline-block;margin-top: 5px;">Precision</span>
										</div>
										<div style="display: inline-block;margin-right: 50px;text-align: center;">
											<img style="width: 60px !important;min-width: 60px !important;" src="../../assets/img/icon_Affordable.png" /><br />
											<span style="display: inline-block;margin-top: 5px;">Affordable</span>
										</div>
										<div style="display: inline-block;text-align: center;">
											<img style="width: 60px !important;min-width: 60px !important;" src="../../assets/img/icon_Easy to Use.png" /><br />
											<span style="display: inline-block;margin-top: 5px;">Use-friendly</span>
										</div>
									</div>
									<div class="btn_box_more btn_box" style="padding: 0 20px;background-color: #0056C2;color: #ffffff;margin-right: 20px;" @click="goBanner(0)">
										<img src="../../assets/img/20231024-095355.png" style="left: -5px;" />Buy Now
									</div>
									<div class="btn_box_more btn_box" style="padding: 0 20px;margin-right: 20px;" @click="goBanner(1)">
										LEARN MORE<img src="../../assets/img/组 32@2x.png" />
									</div>
								</div>
								<div class="right"></div>
							</div>
							<img class="bg_banner" src="../../assets/banner/PC/bg_20240814.webp" />
						</div>
					</van-swipe-item> -->
					<van-swipe-item>
						<div class="banner_el banner_el3">
							<div v-if="isRload" class="msg_box2">
								<div class="left">
									<img class="img1" src="../../assets/banner/PC/20241231/text.webp" style="width: 76%;" />
									<div class="btn_box">
										<img class="btn1" src="../../assets/banner/PC/20241231/btn.webp" style="width: 220px;" @click="goBanner(2)" />
									</div>
								</div>
								<div class="right"></div>
							</div>
							<img class="bg_banner" src="../../assets/banner/PC/20241231/bg.webp" />
						</div>
					</van-swipe-item>
					<van-swipe-item>
						<div class="banner_el banner_el3">
							<div v-if="isRload" class="msg_box2">
								<div class="left">
									<img class="img1" src="../../assets/img_zt/20240828/pc/txt.png" />
									<div class="btn_box">
										<img class="btn1" src="../../assets/img_zt/20240828/pc/button.webp" @click="goBanner(7)" />
									</div>
								</div>
								<div class="right"></div>
							</div>
							<img class="bg_banner" src="../../assets/img_zt/20240828/pc/bg.webp" />
						</div>
					</van-swipe-item>
				</van-swipe>
				<div class="sp_buttons">
					<div class="btn_el" :class="nowIndex == 0 ? 'actived' : ''" @click="checkBanner(0)"></div>
					<div class="btn_el" :class="nowIndex == 1 ? 'actived' : ''" @click="checkBanner(1)"></div>
					<div class="btn_el" :class="nowIndex == 2 ? 'actived' : ''" @click="checkBanner(2)"></div>
					<div class="btn_el" :class="nowIndex == 3 ? 'actived' : ''" @click="checkBanner(3)"></div>
					<div class="btn_el" :class="nowIndex == 4 ? 'actived' : ''" @click="checkBanner(4)"></div>
					<div class="btn_el" :class="nowIndex == 5 ? 'actived' : ''" @click="checkBanner(5)"></div>
					<div class="btn_el" :class="nowIndex == 6 ? 'actived' : ''" @click="checkBanner(6)"></div>
				</div>
			</div>
			<!--广告块-->
			<!-- <div v-if="false" class="adver_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="adver_main">
					<div class="adver_el" style="cursor: pointer;" @click="goFreeSample">
						<img class="icon" src="../../assets/img_public/icon_1.png" />
						<div class="tit">Free Sample</div>
					</div>
					<div class="adver_el">
						<img class="icon" src="../../assets/img_public/icon_2.png" />
						<div class="tit">Promotion Codes & Coupons</div>
					</div>
					<div class="adver_el">
						<img class="icon" src="../../assets/img_public/icon_3.png" />
						<div class="tit">Quick Order</div>
					</div>
					<div class="adver_el">
						<img class="icon" src="../../assets/img_public/icon_4.png" />
						<div class="tit">Get Support</div>
					</div>
				</div>
			</div> -->
			<!--广告块-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_1_main">
					<div class="left">
						<div class="img_box">
							<img src="../../assets/img/image@2x.webp" />
						</div>
						<div class="msg_box">
							<div class="tit">World-Class Diagnostics</div>
							<div class="txt">CorDx pushes the limits of innovation in global health. We empower families and healthcare providers around the world with rapid, accurate, and reliable diagnostic solutions, all with a dedication to quality.</div>
						</div>
						<div class="btn_box_more btn_box" @click="goDiagnostics">
							Learn More<img src="../../assets/img/组 32@2x.png" />
						</div>
					</div>
					<div class="right">
						<div class="img_box">
							<img src="../../assets/img/image@2x (1).webp" />
						</div>
						<div class="msg_box">
							<div class="tit">World-Class Supply Chain</div>
							<div class="txt">We ensure diagnostics products are available to those who need them, when they need them. Our integrated supply chain removes barriers to accessibility and provides cost savings, flexibility, and more.</div>
						</div>
						<div class="btn_box_more btn_box" @click="goSupplyChain">
							Learn More<img src="../../assets/img/组 32@2x.png" />
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="block_2_main">
					<div class="block_2_el"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="img_box" style="padding-right: 50px;">
							<img src="../../assets/img/image01@2x.webp" />
						</div>
						<div class="msg_box" style="padding-left: 50px;">
							<div class="tit">About CorDx​</div>
							<div class="txt">CorDx is transforming the global diagnostics industry with innovative R&D solutions, a vertically integrated supply chain, and manufacturing footprints in the US and around the world.</div>
							<div class="btn_box_more" @click="goAbout">
								Learn More<img src="../../assets/img/组 32@2x.png" />
							</div>
						</div>
					</div>
					<div class="block_2_el"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="msg_box" style="padding-right: 50px;">
							<div class="tit">Partnerships​</div>
							<div class="txt">We partner with organizations around the world to develop, manufacture, and supply diagnostics that empower users to monitor and improve their health.<br />Do you have a breakthrough you believe will benefit <br />from collaboration with CorDx?</div>
							<div class="btn_box_more" @click="goPartnering">
								Learn More<img src="../../assets/img/组 32@2x.png" />
							</div>
						</div>
						<div class="img_box" style="padding-left: 50px;">
							<img src="../../assets/img/image02@2x.webp" />
						</div>
					</div>
					<div class="block_2_el"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="img_box" style="padding-right: 50px;">
							<img src="../../assets/img/image03@2x.webp" />
						</div>
						<div class="msg_box" style="padding-left: 50px;">
							<div class="tit">​CorDx Union</div>
							<div class="txt">CorDx is a CorDx Union company, a biotechnology organization that delivers medical device solutions <br />to healthcare industries and over a billion users <br />in more than 170 countries.</div>
							<div class="btn_box_more" @click="goAbout">
								Learn More<img src="../../assets/img/组 32@2x.png" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="block_3_main"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="title">Recent News</div>
					<div class="block_3_box">
						<div
							v-for="(value, index) in newsData"
							:key="index"
							class="block_3_el"
							@mouseover="newsOver(value.id)"
							@mouseleave="newsLeave"
							@click="goResourcesInfo(value)"
						>
							<img :src="value.image" />
							<div class="msg_box">
								<div class="txt">{{ value.title }}</div>
							</div>
							<div class="time">{{ value.fabu_time }}</div>
							<div v-if="isShow == value.id" class="mask_box"
								data-aos="fade-up"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							>
								<div class="mask_tit">{{ value.title }}</div>
								<div class="mask_txt">{{ value.description }}</div>
							</div>
						</div>
					</div>
					<div class="btn_box_more" style="position: absolute;left: 50%;transform: translate(-50%, 0px);" @click="goResources">
						View More<img src="../../assets/img/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4">
				<div class="block_4_main"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="title">Additional Resources</div>
					<div class="block_4_box">
						<div class="block_4_el" @click="goMediaRoom">
							<img src="../../assets/img/image@2x (1).webp" style="height: 240px;" />
							<div class="msg_box">
								<div class="tit">
									Media room
									<img src="../../assets/img/组 32@2x.png" />
								</div>
								<div class="txt">
									Read the latest CorDx news, download our press kit, and access other resources tailored for the needs of journalists.
								</div>
							</div>
						</div>
						<div class="block_4_el" @click="goProducts">
							<img src="../../assets/img/蒙版组 1@2x (4).webp" />
							<div class="msg_box">
								<div class="tit">
									Products
									<img src="../../assets/img/组 32@2x.png" />
								</div>
								<div class="txt">
									Our proprietary line of diagnostics solutions is recognized by families and medical professionals for their reliability, affordability, and rapid results.
								</div>
							</div>
						</div>
						<div class="block_4_el" @click="goCareers">
							<img src="../../assets/img/蒙版组 1@2x (5).webp" />
							<div class="msg_box">
								<div class="tit">
									Careers
									<img src="../../assets/img/组 32@2x.png" />
								</div>
								<div class="txt">
									We’re hiring! Work with the exceptional team that is transforming the diagnostics industry. Explore opportunities to build your career with CorDx.
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块4-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
			<!--广告块-->
			<!-- <div v-if="isFreeShow" class="free_fixed"
				data-aos="fade-left"
				data-aos-duration="400"
				data-aos-delay="300"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img class="free_1" src="../../assets/img_public/icon_free.webp" @click="goFreeSample" />
				<img class="free_2" src="../../assets/img_public/icon_close.webp" @click="isFreeShow = false;" />
			</div> -->
			<!--广告块-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
import { resourcesList } from '@/api/public';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			navData: '',//JSON.parse(sessionStorage.getItem('navData')),
			lang: sessionStorage.getItem('lang'),
			nowIndex: 0,  //当前banner索引
			isRload: false,
			isShow: null,
			newsData: [],  //新闻数据
			isFreeShow: true,
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		document.title = 'Home - CorDx';
		resourcesList({
			catid: 1,
			page: 1,
			page_size: 3,
			language: sessionStorage.getItem('lang'),
		}).then(res2 => {
			that.newsData = res2.data.data;
		});
	},
	mounted() {
		let that = this;
		setTimeout(() => {
			that.isRload = true;
		}, 300);
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击酒会注册
		goZc() {
			let that = this;
			window.open('https://cordx.com/ADLM/202507/index.html#/index');
		},
		//点击查看goFreeSample详情
		goFreeSample() {
			this.$router.push({ path: '/free-sample', });
		},
		//点击进去新闻详情
		goResourcesInfo(value) {
			let that = this;
			// let { href } = that.$router.resolve({
			// 	path: '/resources-info',
			// 	query: {
			// 		id: value.unionid,
			// 	}
			// });
			// window.open(href, '_blank');
			let routeData = that.$router.resolve({name: "Resourcesinfo", params: { resourcesInfoId: value.custom } });
			window.open(routeData.href, '_blank');
		},
		//banner切换
		bannerLeftClick(value) {  //导航左侧按钮点击
			let that = this;
			that.$refs.swipeDom.prev();
		},
		bannerRightClick(value) {  //导航右侧按钮点击
			let that = this;
			that.$refs.swipeDom.next();
		},
		//切换banner
		checkBanner(index) {
			let that = this;
			that.isRload = false;
			if(index > that.nowIndex) {
				that.$refs.swipeDom.next();
			}else if(index < that.nowIndex){
				that.$refs.swipeDom.prev();
			}
			// switch(index) {
			// 	case 0:
			// 		that.nowIndex = 0;
			// 		that.$refs.swipeDom.next();
			// 	break;
			// 	case 1:
			// 		that.nowIndex = 1;
			// 		that.$refs.swipeDom.next();
			// 	break;
			// 	case 2:
			// 		that.nowIndex = 2;
			// 		that.$refs.swipeDom.next();
			// 	break;
			// 	case 3:
			// 		that.nowIndex = 3;
			// 		that.$refs.swipeDom.next();
			// 	break;
			// 	case 4:
			// 		that.nowIndex = 4;
			// 		that.$refs.swipeDom.next();
			// 	break;
			// }
			setTimeout(() => {
				that.isRload = true;
			}, 400);
		},
		//轮播切换
		spChange(index) {
			let that = this;
			that.isRload = false;
			switch(index) {
				case 0:
					that.nowIndex = 0;
				break;
				case 1:
					that.nowIndex = 1;
				break;
				case 2:
					that.nowIndex = 2;
				break;
				case 3:
					that.nowIndex = 3;
				break;
				case 4:
					that.nowIndex = 4;
				break;
				case 5:
					that.nowIndex = 5;
				break;
				case 6:
					that.nowIndex = 6;
				break;
			}
			setTimeout(() => {
				that.isRload = true;
			}, 400);
		},
		//新闻滑入
		newsOver(value) {
			let that = this;
			that.isShow = value;
		},
		//新闻滑出
		newsLeave() {
			let that = this;
			that.isShow = null;
		},
		goBanner(index) {
			let that = this;
			switch (index){
				case 0:
					window.open('https://al21.com/products/cordx-tyfast-covid-19-ag-rapid-test', '_blank');
					break;
				case 1:
					let routeData = that.$router.resolve({name: "Productsinfos3", params: { productInfoIds: 'cordx-tyfast-covid-19-ag-rapid-test' } });
					window.open(routeData.href, '_blank');
					break;
				case 2:
					that.$router.push({ path: '/partnering', });
					break;
				case 3:
					// let routeData1 = that.$router.resolve({ path: '/cordx-tyfast-mutiplex-rapid-test-poc', });
					// window.open(routeData1.href, '_blank');
					// window.open('https://pages.cordx.com/free-sample-kit');
					that.$router.push({ path: '/free-sample-kit', });
					break;
				case 4:
					let routeData2 = that.$router.resolve({name: "Productsinfos2", params: { productInfoIds: 'cordx-tyfast-flu-a-b-covid-19-at-home-rapid-multiplex-test-cordx' } });
					window.open(routeData2.href, '_blank');
					break;
				case 5:
					window.open('https://www.amazon.com/At-Home-CorDx-COVID-19-Accurate-Results/dp/B0D2DQBJS2?maas=maas_adg_EAA5E1BA3E43283FC76983FA6B2A9AFF_afap_abs&ref_=aa_maas&tag=maas');
					break;
				case 6:
					window.open('https://al21.com/products/cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test');
					break;
				case 7:
					window.open('https://today.ucsd.edu/story/21-million-gift-to-uc-san-diego-honors-unique-efforts-to-link-chemical-and-nano-engineering-more-strongly');
					break;
				case 8:
					window.open('https://www.amazon.com/CorDx-at-Home-COVID-19-Accurate-Minutes/dp/B0DCGQD733/ref=sr_1_2?dib=eyJ2IjoiMSJ9.qPIqXjUO2rxpoT5h05pWhQx6kDgP_v0uorAD6GWXNf8.EKhTgxT-iw6B5dzlM91jcO7Zpw9mTBvmXzxfRY8WDrA&dib_tag=se&m=A1EZ8UG06NJCKU&marketplaceID=ATVPDKIKX0DER&qid=1724849517&s=merchant-items&sr=1-2');
					break;
				case 9:
					// window.open('https://pages.cordx.com/become-a-distributor');
					that.$router.push({ path: '/become-a-distributor' });
					break;
				case 10:
					// window.open('https://pages.cordx.com/become-a-distributor');
					// that.$router.push({ path: '/contact' });
					// window.open('https://page.cordx.com/rsv/');
					break;
				case 11:
					window.open('https://page.cordx.com/rsv/');
					// let routeData3 = that.$router.resolve({name: "Productsinfos5", params: { productInfoIds: 'cordx-tyfast-rsv-rapid-test' } });
					// window.open(routeData3.href, '_blank');
					break;
				case 12:
					window.open('https://page.cordx.com/covid-poc-510k/');
					// let routeData3 = that.$router.resolve({name: "Productsinfos5", params: { productInfoIds: 'cordx-tyfast-rsv-rapid-test' } });
					// window.open(routeData3.href, '_blank');
					break;
				case 13:
					that.$router.push({ path: '/contract-manufacturing' });
					break;
				case 14:
					that.$router.push({ path: '/contact' });
					break;
			}
		},
		goDiagnostics() {  //供应链详情
			this.$router.push({ path: '/diagnostics', });
		},
		goSupplyChain() {  //诊断详情
			this.$router.push({ path: '/supply-chain', });
		},
		goAbout() {
			this.$router.push({ path: '/about', });
		},
		goPartnering() {
			this.$router.push({ path: '/partnering', });
		},
		goResources() {
			this.$router.push({ path: '/resources', });
		},
		goMediaRoom() {
			this.$router.push({ path: '/media-room', });
		},
		goProducts() {
			this.$router.push({ path: '/product/all', });
		},
		goCareers() {
			this.$router.push({ path: '/careers', });
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	.tips_box{
		height: 80px;
		display: flex;
		// background-color: #FFF6E2;
		background-color: #000000;
		.notice_box{
			width: 100%;
			height: 80px;
			margin: 0 auto;
			position: relative;
			display: flex;
			.left{
				padding-left: 3%;
			}
			.right{
				padding-right: 3%;
			}
			.icon{
				flex: 1;
				display: flex;
				align-items: center;
				.el{
					flex: 1;
					text-align: center;
					img{
						height: 35px;
					}
				}
			}
			.notice-wrap{
				width: 1140px;
				height: 80px;
			}
		}
		.tips_main{
			width: 1140px;
			height: 80px;
			display: flex;
			align-items: center;
			margin: 0 auto;
			.left{
				flex: 1;
				.tips{
					width: 30px;
				}
			}
			.right{
				width: 50px;
				img{
					width: 100%;
				}
			}
		}
	}
	.free_fixed{
		position: fixed;
		right: 15px;
		bottom: 15px;
		z-index: 9;
		.free_1{
			width: 250px;
			cursor: pointer;
		}
		.free_2{
			position: absolute;
			right: 10px;
			top: 10px;
			width: 30px;
			cursor: pointer;
			z-index: 1;
		}
	}
	/*轮播图*/
	.banner_box{
		width: 100%;
		position: relative;
		.icon_left{
			left: 50px;
		}
		.icon_right{
			right: 50px;
		}
		.icon_left, .icon_right{
			position: absolute;
			z-index: 1;
			top: 50%;
			margin-top: -18px;
			background: #0B318F;
			border-radius: 50%;
			width: 36px;
			height: 36px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
		}
		.banner_el7{
			position: relative;
			.msg_box2{
				position: absolute;
				z-index: 2;
				display: flex;
				align-items: center;
				width: 100%;
				height: 100%;
				left:  50%;
				transform: translate(-50%, 0);
				.left{
					flex: 1;
					padding-left: 100px;
					text-align: center;
					.btn_box{
						padding-top: 45px;
						img.btn1{
							width: 30%;
						}
					}
					.img1{
						width: 75%;
					}
				}
				.right{
					flex: 1;
				}
			}
		}
		.banner_el6{
			position: relative;
			.msg_box{
				position: absolute;
				z-index: 2;
				display: flex;
				align-items: center;
				width: 1200px;
				height: 100%;
				left:  50%;
				transform: translate(-50%, 0);
				.left{
					flex: 1.6 !important;
				}
				.right{
					flex: 1;
					.btn_box{
						padding-top: 30px;
						img.btn1{
							width: 200px;
						}
					}
					.img1{
						width: 95%;
					}
				}
			}
		}
		.banner_el5{
			position: relative;
			.msg_box2{
				position: absolute;
				z-index: 2;
				display: flex;
				align-items: center;
				width: 1200px;
				height: 100%;
				left:  50%;
				transform: translate(-50%, 0);
				.left{
					flex: 1;
					.img1{
						width: 95%;
					}
				}
				.right{
					flex: 1;
					padding-top: 8%;
					.img1{
						width: 95%;
					}
				}
			}
		}
		.banner_el4{
			position: relative;
			.msg_box2{
				position: absolute;
				z-index: 2;
				display: flex;
				align-items: center;
				width: 1200px;
				height: 100%;
				left:  50%;
				transform: translate(-50%, 0);
				.left{
					flex: 1;
				}
				.right{
					flex: 1.25;
					.btn_box{
						width: 80%;
						padding-top: 30px;
						text-align: center;
						img{
							width: 60%;
						}
					}
					.img1{
						width: 80%;
					}
				}
			}
		}
		.banner_el3{
			position: relative;
			.msg_box2{
				position: absolute;
				z-index: 2;
				display: flex;
				align-items: center;
				width: 1200px;
				height: 100%;
				left:  50%;
				transform: translate(-50%, 0);
				.left{
					flex: 1;
					.btn_box{
						padding-top: 40px;
						img.btn1{
							width: 180px;
							margin-right: 34px;
						}
					}
					.img1{
						width: 75%;
					}
				}
				.right{
					flex: 1;
				}
			}
		}
		.banner_el2{
			position: relative;
			.msg_box2{
				position: absolute;
				z-index: 2;
				display: flex;
				align-items: center;
				width: 1200px;
				height: 100%;
				left: 6%;
				transform: translate(0%, 0);
				.left{
					flex: 1;
					position: relative;
					height: 100%;
					.btn_box3{
						position: absolute;
						bottom: 5%;
						left: 0;
						.btn_el{
							padding: 40px 30px 30px 30px;
							.van-button__text{
								font-size: 38px;
								font-weight: bold;
							}
						}
					}
					.btn_box2{
						padding-top: 28px;
						img.btn3{
							height: 46px;
						}
					}
					.btn_box{
						padding-top: 45px;
						img.btn1{
							width: 240px;
							margin-right: 34px;
						}
						img.btn2{
							width: 195px;
						}
					}
					.img1{
						width: 100%;
					}
				}
				.right{
					flex: 1;
				}
			}
			.bg_banner{
				width: 100%;
			}
		}
		.sp_buttons{
			position: absolute;
			left: 50%;
			bottom: 8px;
			transform: translate(-50%, 0);
			.actived{
				background-color: #0B318F;
			}
			.btn_el{
				display: inline-block;
				width: 8px;
				height: 8px;
				margin: 8px 4px 0 4px;
				border: 1px solid #0B318F;
				border-radius: 50%;
				cursor: pointer;
			}
		}
		.banner_el{
			position: relative;
			.icon_right{
				width: 240px;
				position: absolute;
				right: 0;
			}
			.msg_box{
				position: absolute;
				z-index: 2;
				display: flex;
				align-items: center;
				width: 1200px;
				height: 100%;
				left:  50%;
				transform: translate(-50%, 0);
				.left_spec{
					flex: 1;
					.txt1{
						width: 100%;
					}
					.txt2{
						margin-top: 18px;
						width: 56%;
					}
					.btn_box_spec{
						margin-top: 40px;
						padding: 0 38px;
						background-image: linear-gradient(to right, #0B318F, #0074BC);
						color: #ffffff;
					}
				}
				.right_spec{
					flex: 1;
					position: relative;
				}
				.left{
					flex: 1;
					.tit{
						font-size: 45px;
						line-height: 1.2;
						color: #0B318F;
					}
					.txt{
						padding-top: 25px;
						font-size: 20px;
						color: #0B318F;
					}
					.btn_box{
						margin-top: 35px;
					}
				}
				.right{
					flex: 1;
				}
			}
			.mask_box{
				display: flex;
				position: absolute;
				z-index: 1;
				width: 100%;
				height: 100%;
				.left{
					flex: 1;
					background-color: #ffffff;
				}
				.right{
					flex: 1;
					background: linear-gradient(to right, #ffffff, transparent);
				}
			}
			img.bg_banner{
				//aspect-ratio: 1920/614;
				aspect-ratio: 1920/650;
			}
			img.bg_banner{
				width: 100%;
				min-width: 1440px;
				object-fit: cover;
				// aspect-ratio: 1920/614;
			}
		}
	}
	/*广告*/
	.adver_box{
		padding: 24px 0 18px 0;
		background: linear-gradient( 90deg, #3A9AFF 0%, #0066D4 100%);
		.adver_main{
			width: 1140px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #BBDBFF;
			.adver_el{
				flex: 1;
				text-align: center;
				.tit{
					padding-top: 10px;
					font-size: 18px;
				}
				.icon{
					width: 48px;
					height: auto;
				}
			}
		}
	}
	/*块4*/
	.block_4{
		width: 100%;
		height: 716px;
		background-color: transparent;
		.block_4_main{
			width: 1140px;
			margin: 0 auto;
			padding: 0px 0 140px 0;
			.block_4_box{
				display: flex;
				padding: 60px 0 0px 0;
				.block_4_el{
					flex: 1;
					position: relative;
					margin: 0 16px;
					background-color: #ffffff;
					cursor: pointer;
					.msg_box{
						width: 100%;
						padding: 20px 0px 0px 0px;
						.tit{
							position: relative;
							font-size: 24px;
							img{
								position: absolute;
								top: 8px;
								right: 0;
								width: 20px;
								transition: all 0.3s;
							}
						}
						.txt{
							padding-top: 20px;
							color: #000000;
							font-size: 20px;
						}
					}
					img{ width: 100%; }
				}
				.block_4_el:hover{
					.tit{
						img{
							transform: translateX(6px);
						}
					}
				}
			}
			.title{
				font-size: 45px;
				color: #000000;
			}
		}
	}
	/*块3*/
	.block_3{
		width: 100%;
		height: 925px;
		background-color: transparent;
		background-image: linear-gradient(180deg,  #F1ECE6 20%, #FFFFFF 100%);
		.block_3_main{
			width: 1140px;
			margin: 0 auto;
			padding: 100px 0 150px 0;
			.block_3_box{
				display: flex;
				padding: 60px 0 50px 0;
				.block_3_el{
					flex: 1;
					position: relative;
					margin: 0 20px;
					background-color: #ffffff;
					box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
					cursor: pointer;
					overflow: hidden;
					.mask_box{
						position: absolute;
						width: 100%;
						height: 100%;
						top: 0;
						background-color: #ffffff;
						padding: 34px;
						.mask_tit{
							font-size: 20px;
							color: #000000;
						}
						.mask_txt{
							padding-top: 40px;
							font-size: 16px;
							color: #706B69;
						}
					}
					.msg_box{
						width: 100%;
						padding: 30px 34px 120px 34px;
						border-top: 2px solid #0B318F;
						.txt{
							color: #000000;
							font-size: 22px;
						}
					}
					.time{
						position: absolute;
						z-index: 2;
						bottom: 40px;
						left: 34px;
						font-size: 18px;
						color: #706B69;
					}
					img{
						width: 100%;
						// height: auto;
						height: 227px;
						object-fit: cover;
					}
				}
			}
			.title{
				font-size: 45px;
				color: #000000;
			}
		}
	}
	/*块2*/
	.block_2{
		width: 100%;
		height: 1575px;
		padding: 235px 0 60px 0;
		.block_2_main{
			width: 1140px;
			margin: 0 auto;
			.block_2_el{
				display: flex;
				align-items: center;
				padding-bottom: 80px;
				.img_box{
					flex: 1;
					img{ width: 100%; }
				}
				.msg_box{
					flex: 1;
					.tit{
						font-size: 45px;
						color: #000000;
					}
					.txt{
						padding: 28px 0 40px 0;
						font-size: 20px;
					}
				}
			}
		}
	}
	/*块1*/
	.block_1{
		width: 100%;
		height: 805px;
		background-color: transparent;
		background-image: linear-gradient(180deg, #FFFFFF 20%, #F1ECE6 100%);
		.block_1_main{
			width: 1140px;
			margin: 0 auto;
			display: flex;
			background-color: #FFFFFF;
			box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
			position: relative;
			top: 95px;
			.left, .right{
				flex: 1;
				position: relative;
				padding: 0 0 55px 0;
				.btn_box{
					position: relative;
					left: 33%;
				}
				.msg_box{
					padding: 30px 38px 100px 38px;
					.tit{
						font-size: 34px;
					}
					.txt{
						padding-top: 20px;
						font-size: 20px;
					}
				}
				.img_box{
					img{ width: 100%; }
				}
			}
		}
	}
	.btn_box_more{
		display: inline-block;
		padding: 0 28px;
		height: 54px;
		line-height: 54px;
		font-size: 20px;
		color: #0B318F;
		background: #FFFFFF;
		border-radius: 27px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px !important;
			min-width: 20px !important;
			position: relative;
			top: 14px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box_more:hover{
		// img{
		// 	transform: translateX(6px);
		// }
		// background-color: #f5f8fa;
	}
}
</style>
<style scoped>
.notice-wrap {
	width: 100%;
	overflow: hidden;
}

/* van-notice-bar 内容区域 */
::v-deep .van-notice-bar__content {
	width: 100%;
	overflow: hidden;
}

/* 跑马灯容器 */
.marquee {
	width: 100%;
	overflow: hidden;
	white-space: nowrap;
}

/* 滚动主体 */
.marquee-content {
	display: inline-flex;
	align-items: center;
	white-space: nowrap;

	/* 无缝滚动 */
	animation: marqueeMove 40s linear 1s infinite;
}

/* 文本 */
.notice-text {
	flex-shrink: 0;
	height: 80px;
	line-height: 80px;
	font-size: 24px;
	letter-spacing: 1px;
	padding-right: 120px;
	color: #ffffff;
}

/* 无缝动画 */
@keyframes marqueeMove {
	from {
		transform: translateX(0);
	}

	to {
		transform: translateX(-50%);
	}
}
</style>
<style scoped>
>>> .notice_box .van-notice-bar{
	height: 80px;
	padding: 0 10px;
}
</style>
